import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

// EditProduct article components
import ArticleImage from "./components/ArticleImage";
import MainInfo from "./components/MainInfo";
import LangForm from "./components/LangForm";

import crudsService from "services/cruds-service";
import { useLocation, useParams } from "react-router-dom";
import i18n from "i18n";
import prepareNewArr from "helper/prepareNewArr";
import deepDiff from "helper/deep-diff";
import { date } from "yup";
import getEmptyFields from "helper/getEmptyFields";
import MDAlert from "components/MDAlert";

function EditArticle() {
  const { t } = i18n;
  const baseUrl = process.env.REACT_APP_API_URL;
  let { pathname } = useLocation();

  const { id } = useParams();
  const [article, setArticle] = useState({
    id: null,
    status: null,
    date: "",
    tags: [],
    sequence: 0,
    title: "",
    slug: "",
    summary: "",
    description: "",
    translations: {},
    mobile_pic: null,
    web_pic: null,
  });
  const [info, setInfo] = useState({
    id: null,
    tags: [],
    sequence: 0,
    date: "",
    status: null,
    title: "",
    slug: "",
    summary: "",
    description: "",
    translations: {},
    mobile_pic: null,
    web_pic: null,
  });
  const [linfo, setLInfo] = useState({
    translations: {},
  });
  const [tags, setTags] = useState([]);

  const [notification, setNotification] = useState({
    value: false,
    color: "info",
    message: "",
  });

  const [errors, setErrors] = useState({
    id: false,
    tags: false,
    sequence: false,
    date: false,
    status: false,
    translations: {
      title: false,
      summary: false,
      description: false,
      slug: false,
    },
    mobile_pic: false,
    web_pic: false,
  });

  const chkErrors = {
    tags: false,
    sequence: false,
    date: false,
    translations: {
      title: false,
      summary: false,
      description: false,
      slug: false,
    },
    web_pic: false,
  };

  const many2manyPrepareNewArr = (arr, name, objKey) => {
    let newArr = [];
    for (const key in arr) {
      if (Object.hasOwnProperty.call(arr, key)) {
        const element = arr[key][name];
        newArr.push({
          id: element?.id,
          name: element?.translations[0][objKey || "name"],
        });
      }
    }
    return newArr;
  };

  const getArticles = async () => {
    // const response = await crudsService.getArticleById(id);
    const response = await crudsService.getAllData(
      `items/article/${id}?fields=*,translations.article_id,translations.description,translations.id,translations.languages_code,translations.summary,translations.title,translations.slug,translations.languages_code.name,translations.languages_code.code,tags.id,tags.tags_id.id,tags.tags_id.translations.*`,
    );

    let tagsArr = [];

    many2manyPrepareNewArr(response.data.tags, "tags_id").forEach((tagItem) => {
      tagsArr.push(tagItem);
    });

    setArticle((prevArticle) => ({
      ...prevArticle,
      translations: response.data.translations.reduce((acc, translation) => {
        acc[translation.languages_code.code] = { ...translation };
        return acc;
      }, {}),
      id: response.data.id,
      title: response.data.translations[0].title,
      slug: response.data.translations[0].slug,
      summary: response.data.translations[0].summary,
      description: response.data.translations[0].description,
      status: response.data.status,
      date: response.data.date,
      tags: tagsArr,
      sequence: response.data.sequence,
      mobile_pic: response.data.mobile_pic,
      web_pic: response.data.web_pic,
    }));
  };

  //if id change (when click edit from articles page) get the article data
  useEffect(() => {
    if (!id) return;
    getArticles();
  }, [id]);

  useEffect(() => {
    (async () => {
      try {
        // const categoryData = await crudsService.getCategories(
        //   `&filter[_and][1][_or][1][parent_id][_nnull]=true&filter[_and][1][_or][2][id][_in]=1,22`
        // );

        const tagsData = await crudsService.getAllData(
          "items/tags?fields=*,translations.name,projects.id&filter[type][_eq]=a",
        );
        setTags(prepareNewArr(tagsData.data));
      } catch (err) {
        console.error(err);
        return null;
      }
    })();
  }, []);

  useEffect(() => {
    if (!article) return;
    setInfo({
      sequence: article?.sequence,
      status: article?.status,
      date: article?.date,
      tags: article?.tags,
      web_pic: article?.web_pic,
      mobile_pic: article?.mobile_pic,
    });
    // setLInfo({
    //   translations: { ...article?.translations },
    // });
  }, [article]);

  const changeHandler = (e, lang) => {
    if (lang) {
      setLInfo({
        translations: {
          ...linfo.translations,
          [lang]: {
            ...linfo.translations[lang],
            [e.target.name]: e.target.value,
            languages_code: lang,
          },
        },
      });
    } else {
      setInfo({
        ...info,
        [e.target.name]: e.target.value,
      });
    }
  };

  const autoSwitchChangeHandler = (name, v) => {
    setInfo({
      ...info,
      [name]: v,
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      const { translations, ...err } = chkErrors;

      let obj = {
        ...getEmptyFields(info, "", err),
        ...getEmptyFields(linfo.translations["ar-SA"], "ar-SA", translations),
        ...getEmptyFields(
          linfo.translations["en-US"] || {
            title: "",
            slug: "",
            summary: "",
            description: "",
          },
          "en-US",
          translations,
        ),
        ...getEmptyFields(
          linfo.translations["tr-TR"] || {
            title: "",
            slug: "",
            summary: "",
            description: "",
          },
          "tr-TR",
          translations,
        ),
      };

      // delete obj["languages_code-ar-SA"];
      // delete obj["languages_code-tr-TR"];
      // delete obj["languages_code-en-US"];

      const hasErrors = Object.values(obj).some((v) => v === true);
      console.log(hasErrors, obj);

      if (hasErrors) {
        setErrors(obj);
        return; // stop
      }

      let route =
        pathname.split("/")[pathname.split("/").length - (id ? 2 : 1)];

      // important ...
      // if create new if status published add date failed automatic date.now else if status draft let date null
      // else if update exist item if status published and date failed null update it to date.now else if date failed exist let it as it is and dont update it

      if (info.web_pic && info.web_pic instanceof File) {
        article.web_pic && (await crudsService.removeFile(article.web_pic));
        const formData = new FormData();
        formData.append("attachment", info.web_pic);
        let img = await crudsService.uploadImage(formData);
        info.web_pic = img.id;
      } else if (info.web_pic === null) {
        delete info.web_pic;
      }

      if (info.mobile_pic && info.mobile_pic instanceof File) {
        article.mobile_pic &&
          (await crudsService.removeFile(article.mobile_pic));
        const formData = new FormData();
        formData.append("attachment", info.mobile_pic);
        let img = await crudsService.uploadImage(formData);
        info.mobile_pic = img.id;
      } else if (info.mobile_pic === null) {
        delete info.mobile_pic;
      }
      // linfo.translations.map(
      //   (t) => (t.slug = t?.slug.trim().replace(/\s+/g, "-")),
      // );
      const trns = Object.values(linfo.translations);
      // console.log({
      //   date: info?.date,
      //   sequence: info?.sequence,
      //   status: info?.status,
      //   tags: info?.tags.map((tag) => ({ tags_id: tag.id })),
      //   mobile_pic: info?.mobile_pic,
      //   web_pic: info?.web_pic,
      //   translations: trns,
      //   type: route === "news" ? "n" : "b",
      // });
      // return;
      if (id) {
        await crudsService.updateItem(`items/article/${id}`, {
          date: info?.date,
          sequence: info?.sequence,
          status: info?.status,
          // tags: info?.tags.map((tag) => ({ tags_id: tag.id })),
          mobile_pic: info?.mobile_pic,
          web_pic: info?.web_pic,
          translations: trns,
        });
      } else {
        await crudsService.createItem(`items/article`, {
          date: info?.date,
          sequence: info?.sequence,
          status: info?.status,
          tags: info?.tags.map((tag) => ({ tags_id: tag.id })),
          mobile_pic: info?.mobile_pic,
          web_pic: info?.web_pic,
          translations: trns,
          type: route === "news" ? "n" : "b",
        });
      }
      setNotification({
        value: true,
        color: "success",
        text: "تم الحفظ بنجاح",
      });
    } catch (err) {
      console.error(err);
      setNotification({
        value: true,
        color: "error",
        text: "حدث خطأ ما، الرجاء المحاولة مرة أخرى",
      });
    }
  };

  return (
    <DashboardLayout>
      {/* <DashboardNavbar /> */}
      <MDBox my={3}>
        <MDBox mb={6}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDTypography variant="h4" fontWeight="medium">
                {!id ? "صفحة المقال" : article.title}
              </MDTypography>
            </Grid>
            <Grid item xs={12} lg={6}>
              <MDBox display="flex" justifyContent="flex-end">
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={submitHandler}
                >
                  {t("save")}
                </MDButton>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        {notification.value === true && (
          <MDAlert color={notification.color} mt="20px">
            <MDTypography variant="body2" color="white">
              {notification.text}
            </MDTypography>
          </MDAlert>
        )}
        <Grid container spacing={3}>
          <Grid item xs={12} lg={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <MainInfo
                  article={article}
                  setArticle={setArticle}
                  tags={tags}
                  changeHandler={changeHandler}
                  autoSwitchChangeHandler={autoSwitchChangeHandler}
                  setInfo={setInfo}
                  info={info}
                  setErrors={setErrors}
                  errors={errors}
                  notification={notification}
                  setNotification={setNotification}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <ArticleImage
                  articleImage={
                    article.web_pic
                      ? `${baseUrl}assets/${article?.web_pic}`
                      : null
                  }
                  changeHandler={changeHandler}
                  imgInfo={{ name: "صورة الموقع", dimentions: "" }}
                  setInfo={setInfo}
                  info={info}
                  notification={notification}
                  setNotification={setNotification}
                  errors={errors}
                  setErrors={setErrors}
                  name="web_pic"
                />
              </Grid>
              {/* <Grid item xs={12} lg={12}>
                <ArticleImage
                  articleImage={
                    article?.mobile_pic
                      ? `${baseUrl}assets/${article?.mobile_pic}`
                      : null
                  }
                  changeHandler={changeHandler}
                  imgInfo={{ name: "صورة الهاتف", dimentions: "300x300" }}
                  setInfo={setInfo}
                  info={info}
                  notification={notification}
                  setNotification={setNotification}
                  errors={errors}
                  setErrors={setErrors}
                  name="mobile_pic"
                />
              </Grid> */}
            </Grid>
          </Grid>
          <Grid item xs={12} lg={9}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <LangForm
                  article={article}
                  changeHandler={changeHandler}
                  setInfo={setLInfo}
                  info={linfo}
                  notification={notification}
                  setNotification={setNotification}
                  errors={errors}
                  setErrors={setErrors}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EditArticle;
